import axios, { InternalAxiosRequestConfig } from "axios";

declare global {
  interface Window {
    __ENV__: {
      BASE_URL: string;
      DB_NAME?: string;
    };
  }
}

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, "");

export const baseUrl = `${normalizeBaseUrl(window.__ENV__?.BASE_URL || "")}`;

export const baseUrlApi = `${baseUrl}/v1/`;

export const odooDbName = (window.__ENV__?.DB_NAME || "").trim();

/** Append ?db=… for multi-database Odoo hosts (e.g. erp-test). */
export function attachOdooDbParam<T extends InternalAxiosRequestConfig>(
  config: T
): T {
  if (!odooDbName) return config;

  const url = config.url || "";
  const base = config.baseURL || "";
  const full = `${base}${url}`;
  if (full.startsWith("/hyperpay/") || full.includes("oppwa.com")) return config;
  const isOdoo =
    full.includes("/v1/") ||
    full.includes("/v1?") ||
    url.startsWith("/v1") ||
    base.includes("/v1") ||
    (Boolean(baseUrl) && full.startsWith(baseUrl));

  if (isOdoo) {
    config.params = { ...config.params, db: odooDbName };
  }
  return config;
}

axios.interceptors.request.use(attachOdooDbParam);
